module.exports = __webpack_public_path__ + "img/aluren.902cdb7e.jpg";